import { action, makeObservable, observable } from 'mobx';
import { makePersistable } from 'mobx-persist-store';

export class FiscalControlStore {
  startDate: string = '';
  endDate: string = '';
  selectedDateRange: string = '';

  constructor() {
    makeObservable(this, {
      startDate: observable,
      endDate: observable,
      selectedDateRange: observable,
      setStartDate: action,
      setEndDate: action,
      setSelectedDateRange: action,
      removeData: action,
    });
    makePersistable(this, {
      name: 'FiscalControlStore',
      properties: ['startDate', 'endDate', 'selectedDateRange'],
      storage: window.localStorage,
    });
  }

  setStartDate(startDate: string) {
    this.startDate = startDate;
  }
  setEndDate(endDate: string) {
    this.endDate = endDate;
  }
  setSelectedDateRange(range: string) {
    this.selectedDateRange = range;
  }
  removeData() {
    this.startDate = '';
    this.endDate = '';
    this.selectedDateRange = '';
  }
}
